import { BaseService, Service } from "/@/cool";
@Service("productShopPrice")
class ShopBot extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["skuConfig"] = prefix + "skuConfig";
		this.permission["saveSkuSettings"] = prefix + "saveSkuSettings";
	}

	skuConfig(data: any) {
		return this.request({
			url: "/skuConfig",
			method: "POST",
			data
		});
	}

	saveSkuSettings(data: any) {
		return this.request({
			url: "/saveSkuSettings",
			method: "POST",
			data
		});
	}
}
export default ShopBot;
